module.exports = __webpack_public_path__ + "img/AT0000258998564.fd5bf056.svg";